<template>
  <div class="text-center">
    <PrimeVueImage
      :src="imageSrc"
      imageStyle="max-width: 100%; max-height:500px;"
      v-if="imageSrc"
    />
    <p class="text-center text-secondary" v-else>no photo uploaded</p>
  </div>
</template>

<script>
import PrimeVueImage from "@/components/info_cards/PrimeVueImage.vue";
import UploadProvider from "@/services/upload.provider";

const uploadProvider = new UploadProvider();

export default {
  name: "SectionTwo",

  components: {
    PrimeVueImage,
  },

  data: () => ({
    loading: false,
    rand: null,
    imageSrc: null,
  }),

  computed: {
    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },
    student_id() {
      return this.$store.state.user.surrogated_student_id;
    },
  },

  methods: {
    async fetchData() {
      this.loading = true;
      if (this.imageSrc) {
        window.URL.revokeObjectURL(this.imageSrc);
        this.rand = Math.random();
      }
      const data = await uploadProvider
        .getStudentCardPhoto({
          uid: this.uid,
          student_id: this.student_id,
          rand: this.rand,
        })
        .catch(() => {});
      if (data) {
        this.imageSrc = window.URL.createObjectURL(data);
      }
      this.loading = false;
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style scoped></style>
